module.exports = __webpack_public_path__ + "img/xh.0d9dc611.png";